import setPersonalSchedulingPage from '../services/setPersonalSchedulingPage';
import PublishingSettings from 'owa-service/lib/contract/PublishingSettings';
import updatePublishingSettings from '../data/actions/updatePublishingSettings';
import setIsSaving from '../data/actions/setIsSaving';
import { trace } from 'owa-trace';

/**
 * Triggers a service call to update the personal booking page publishing status and mutate the store.
 */
export default async function setPublishedStatus(isPublished: boolean) {
    let pbpPublishingSettings: PublishingSettings = {
        IsPublished: isPublished,
    };

    try {
        setIsSaving(true);
        let result = await setPersonalSchedulingPage(pbpPublishingSettings);
        if (!result) {
            return;
        }

        pbpPublishingSettings.PublishedUrl = result.PublishedUrl;
        updatePublishingSettings(pbpPublishingSettings);
    } catch (e) {
        trace.warn(e.message || 'setPublishedStatus failed');
    } finally {
        setIsSaving(false);
    }
}
